import { Component, OnInit, OnDestroy } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers/index';

import * as fromNewData from './../store/new-data.actions';
import * as XLSX from 'xlsx';
import { NewData } from '../models/new-data.model';
import { Subscription, Observable } from 'rxjs';
import { getNewData, getIsLoading } from '../store/new-data.selectors';
import { take, map } from 'rxjs/operators';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { ConfirmSaveModalComponent } from '../../shared/components/confirm-save-modal/confirm-save-modal.component'
import { NewdataModalComponent } from '../../shared/components/newdata-modal/newdata-modal.component';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-new-data-found',
  templateUrl: './new-data-found.component.html', 
  styleUrls: ['./new-data-found.component.scss']
}) 
export class NewDataFoundComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean>;
  newdata: NewData[] | any = [];
  modalRef: MDBModalRef;

  newdataSub: Subscription;

  modalConfig = {
    class: 'modal-dialog-centered'
  };

  lastNewDataIndex: number;

  constructor(private modalService: MDBModalService, private store: Store<AppState>, private afAuth: AngularFireAuth) { }

  ngOnInit() {
    this.isLoading$ = this.store.select(getIsLoading);

    this.newdataSub = this.store.select(getNewData).pipe(
      map( (newdata: NewData[]) => {
        if (this.user && !newdata) {
          this.store.dispatch(new fromNewData.NewDataQuery());
        }
        return newdata;
      })
    )
    .subscribe( (newdata: NewData[]) => {
      if (newdata && newdata.length !== 0) {
        const index: number = Number(newdata[newdata.length - 1].id);
        this.lastNewDataIndex = index;
      } else {
        this.lastNewDataIndex = 0;
      }

      this.newdata = newdata;
    });
  }

  get user() {
    return this.afAuth.auth.currentUser;
  }

  ngOnDestroy() {
    if (this.newdataSub) {
      this.newdataSub.unsubscribe();
    }
  }

  onAddNewData() {
    this.modalRef = this.modalService.show(NewdataModalComponent, this.modalConfig);

    this.modalRef.content.heading = 'Add new record';
    this.modalRef.content.newdata.id = this.lastNewDataIndex + 1;

    this.modalRef.content.newdataData.pipe(take(1)).subscribe( (newdataData: NewData) => {
      this.store.dispatch(new fromNewData.NewDataAdded({ newdata: newdataData }));
    });
  }

  openEditNewDataModal(newdata: NewData) {
    this.modalRef = this.modalService.show(NewdataModalComponent, this.modalConfig);

    this.modalRef.content.heading = 'Save record';
    const newdataCopy = {
      key: newdata.key,
      phone: newdata.phone || newdata.phone,
      page: newdata.page || newdata.page,
      address: newdata.address || newdata.address,
      name: newdata.name || newdata.name, 
      date: newdata.date || newdata.date,
      lead: newdata.lead || newdata.lead,
      postcode: newdata.postcode || newdata.postcode,
      status: newdata.status || newdata.status,
      phone2: newdata.phone2 || newdata.phone2,
      industry: newdata.industry || newdata.industry, 
      username: newdata.username || newdata.username

    
     };
    this.modalRef.content.newdata = newdataCopy;

    this.modalRef.content.newdataData.pipe(take(1)).subscribe( (newdataData: NewData) => {
      this.store.dispatch(new fromNewData.NewDataEdited({ newdata: newdataData }));
    });
  }

  openConfirmModal(newdata: NewData) {
    this.modalRef = this.modalService.show(ConfirmModalComponent, this.modalConfig);

    this.modalRef.content.confirmation.pipe(take(1)).subscribe( (confirmation: boolean) => {
      if (confirmation) {
        this.store.dispatch(new fromNewData.NewDataDeleted({ newdata }));
      }
    });
  }

  openConfirmSaveModal(newdata: NewData) {
    this.modalRef = this.modalService.show(ConfirmSaveModalComponent, this.modalConfig);

    this.modalRef.content.confirmation.pipe(take(1)).subscribe( (confirmation: boolean) => {
      if (confirmation) {
        this.store.dispatch(new fromNewData.NewDataSaved({ newdata }));
      }
    });

  }

  openConfirmModalSec(newdata: NewData) {
    this.modalRef = this.modalService.show(ConfirmModalComponent, this.modalConfig);

    this.modalRef.content.confirmation.pipe(take(1)).subscribe( (confirmation: boolean) => {
      if (confirmation) {
        this.store.dispatch(new fromNewData.NewDataDeletedAll({ newdata }));
      }
    });
  }

  

  onNewDataEdit(newdata: NewData) {
    this.openEditNewDataModal(newdata);
  }

  onNewDataSave(newdata: NewData) {
    this.openEditNewDataModal(newdata);
  }

  onNewDataDelete(newdata: NewData) {
    this.openConfirmModal(newdata);
  }

  onNewDataDeleteAll(newdata: NewData) {
    this.openConfirmModalSec(newdata);
  }

  exportExcel() {
    const workSheet = XLSX.utils.json_to_sheet(this.newdata);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Data Found');
    XLSX.writeFile(workBook, 'data_found.xls');
}



}
